import React, { Component, Fragment } from 'react';

export default class SearchFilter extends Component {

    state = {
        value: "",
    }
    componentWillMount() {
        const { byOption } = this.props

        this.setState({
            byOption,
        }, () => {

            // this.props.filterSelect !== "" && this.state.byOption.length > 0 && this.props._selectBy(byOption[0].value)
        });
        document.addEventListener("keydown", this.onEnter)
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onEnter)
    }

    onEnter = (event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
            this.props.searchFunc()
        }
    }

    componentWillReceiveProps(nextProps) {
        const { byOption } = nextProps
        this.setState({
            byOption,
        })
    }

    render() {
        const { byOption } = this.state
        const { _selectBy, _inputChangeSearchQuery, searchFunc, resetFunc } = this.props
        return (
            <div class="col-md-12">
                <div class="col-md-8 product-form pr-0">
                    <div class="col-md-6 step-one">
                        <div class="form-group">
                            <label for="phone" className="mb-0">
                                BY
                            </label>
                            <select
                                id="filterSelect"
                                class="form-control"
                                name=""
                                onChange={(e) => _selectBy(e.target.value)}
                                value={this.props.filterSelect}
                            >
                                <option value="" selected disabled>--select--</option>
                                {byOption.map((data, i) => {
                                    return (byOption !== "_id") && <option key={i} value={data.value}>{data.label}</option>
                                }
                                )}

                            </select>
                        </div>
                    </div>
                    <div class="col-md-6 step-one">
                        <div class="form-group">
                            <label for="ref-no">FOR</label>
                            <input type="text" class="form-control" name=""
                                value={this.props.inputSearch}
                                onChange={(e) => _inputChangeSearchQuery(e)}
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4 product-form pl-0">
                    <button type="button" class="primary pull-left margin-1" name="button" onClick={() => searchFunc()}>Search</button>
                    <button type="button" class="primary pull-left margin-1 ml-2" name="button" onClick={() => resetFunc()}>reset</button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ListPage/SearchFilter.js